import { routes } from '../config/api_routes'

export const searchService = {

    getPopularSearchData: (formData) => { return window.axios.post(routes.getPopularSearchDataApi, formData) },

    getPopularSearchById: (formData) => { return window.axios.post(routes.getPopularSearchByIdApi, formData) },

    getPopularSearch: (formData) => { return window.axios.post(routes.getPopularSearchApi, formData) },

    getPopularSearchList: (formData) => { return window.axios.post(routes.getPopularSearchListApi, formData) },

    addPopularSearch: (formData) => { return window.axios.post(routes.addPopularSearchApi, formData) },

    editPopularSearch: (formData) => { return window.axios.post(routes.editPopularSearchApi, formData) },

    deletePopularSearch: (formData) => { return window.axios.post(routes.deletePopularSearchApi, formData) },

    updatePopularSearchOrder: (formData) => { return window.axios.post(routes.updatePopularSearchOrderApi, formData) },
}